import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import Layout from 'utils/hocs/layout';
import { applyContexts } from 'utils/providers';

// includes global styles used by library, but optional, like resets
// import '@on2-dev/on2-general-resources/styles/global.css';

// the library styles
import '@on2-dev/on2-general-resources/styles/index.css';

import '@on2-dev/rio-bravo-resources/styles/global.css';

import '@on2-dev/rio-bravo-resources/styles/index.css';

// includes global styles used by library, but optional, like resets
import 'utils/styles/_globals.scss';

import 'utils/styles/_reset.scss';
import { uniquelyIdentifyUser } from '@/utils/functions';

function DEx01Frontend({ Component, pageProps }) {
  const router = useRouter();

  if (router.route === '/sitemap.txt') {
    return <Component {...pageProps} />;
  }

  // ads a uinque, annonimous identifier to the cookies
  uniquelyIdentifyUser();

  const theDateAndTime = new Date(pageProps.generatedAt);

  return applyContexts(
    <Layout>
      <Head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />

        {/* <meta name="revalidate-time" content={Date.now()} /> */}
        <meta
          name="generated-at"
          value={pageProps.generatedAt}
          content={
            theDateAndTime.toLocaleDateString() +
            ' @ ' +
            theDateAndTime.toLocaleTimeString()
          }
        />
        <link rel="sitemap" type="application/xml" title="Sitemap" href="/api/sitemap.xml" />
      </Head>

      <Component {...pageProps} />

    </Layout>,
    { pageProps }
  );
}

export default DEx01Frontend;
